import { useEffect, useState } from "react";
import { Table, Button, Space, Select, Tag, message, Typography, Row, Col } from "antd";
import type { TableColumnsType, TableProps } from "antd";
import FuelVolumeModal from "./FuelVolumeModal";
import {
  CombustionFuelVolume,
  ResponseAPI,
  OptionFilterItem,
  FilterCombustion,
  ExceptionDate,
  TagPI,
  initData,
  InputByEnum,
} from "src/entity/fuel-volume/fuel-volume.entity";
import {
  getFuelVolumeCombustions,
  getFuelVolumeOptionFilterCombust,
  updateFuelVolumeCombust,
  getMasterData,
  getAreaMaster,
  getTaskRunning,
  calculateReportVocEmission,
} from "src/services/combustion.service";
import { CalendarOutlined } from "@ant-design/icons";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { Filter, MasterData, dropdownOption } from "src/entity/statck-info/stackInfo.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canEditTable, canViewTable } from "../../PermissionCheck/PermissionCheck";
import { BsPencilSquare } from "react-icons/bs";
import { componentPalette } from "src/theme/component-palette";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import moment from "moment";
import { covertedRangesDateToStrByFormat } from "src/utils/date-time";
import { EmptyString } from "src/entity/common/unit.constant";
import { generateYearArray } from "src/utils/array";

const { Text } = Typography;

const FuelVolumeTable = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const currentYear = new Date().getFullYear();
  const [companyId, setCompanyId] = useState<string>("");
  const profile = profileStore(useShallow((state) => state.profile));
  const { permissions } = useNavigationMenu();
  const [data, setData] = useState<CombustionFuelVolume[]>();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [showModalFuelVolume, setShowModalFuelVolume] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filterStackId, setFilterStackId] = useState<number[]>();
  const [filterSourceId, setFilterSourceId] = useState<number[]>();
  const [filterArea, setFilterArea] = useState<Filter[]>();
  const [filterFuelName, setFilterFuelName] = useState<string[]>();
  const [filterVolInputBy, setFilterVolInputBy] = useState<string[]>();
  const [filterDensityInputBy, setFilterDensityInputBy] = useState<string[]>();
  const [filterVolTagPI, setFilterVolTagPI] = useState<string[]>();
  const [filterDensityTagPI, setFilterDensityTagPI] = useState<string[]>();
  const [filterExceptionDate, setFilterExceptionDate] = useState<string[]>();
  const [filterCombustion, setFilterCombustion] = useState<FilterCombustion>({
    stackId: null,
    sourceId: null,
    area: null,
    fuelName: null,
    volumeInputBy: null,
    densityInputBy: null,
    volumeTagPI: null,
    densityTagPI: null,
    exceptionDate: null,
  });
  const [areaMaster, setAreaMaster] = useState<dropdownOption[]>([]);
  const [initialData, setInitialData] = useState<CombustionFuelVolume>(initData);
  const [unitMaster, setUnitMaster] = useState<dropdownOption[]>([]);
  const [statusTaskRunning, setStatusTaskRunning] = useState<boolean>(false);
  const formatDate = "YYYY-MM-DD HH:mm";

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }
    if (filterCombustion) {
      const str = Object.entries(filterCombustion)
        .filter(([_, value]) => value != null && value.length > 0)
        .map(([key, value]) => `&${key}=[${[value.join(",")]}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const fetchCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const queryParam = createParamFilter();
        let response = await getFuelVolumeCombustions(companyId, queryParam);
        let responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          setLoading(false);
          // let combustions = responseData.data.combustions.map((el, index) => {
          //   return {
          //     no: (index + offset + 1).toString(),
          //     ...el,
          //   };
          // });
          setData(responseData.data.combustions);
          setTotal(responseData.data.total);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const fetchOptionFilterCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let query = `year=${selectedYear}`;
        let response = await getFuelVolumeOptionFilterCombust(companyId, query);
        let responseData: ResponseAPI = response.data;

        if (responseData.code === 200) {
          const filter = response.data.data.filter;

          if (filter.length) {
            setFilterStackId(filter.find((item: OptionFilterItem) => item.key === "stackId")?.filter ?? []);
            setFilterSourceId(filter.find((item: OptionFilterItem) => item.key === "sourceId")?.filter ?? []);

            const filterArea = filter.find((item: OptionFilterItem) => item.key === "area")?.filter;
            if (areaMaster && filterArea) {
              const optionArea = filterArea.map((el: any) => {
                const resultMap = areaMaster.find((item) => item.value === el);
                return {
                  text: resultMap?.label,
                  value: resultMap?.value,
                };
              });
              setFilterArea(optionArea);
            }

            setFilterFuelName(filter.find((item: OptionFilterItem) => item.key === "fuelName")?.filter ?? []);
            setFilterVolInputBy(filter.find((item: OptionFilterItem) => item.key === "volumeInputBy")?.filter ?? []);
            setFilterDensityInputBy(filter.find((item: OptionFilterItem) => item.key === "densityInputBy")?.filter ?? []);
            setFilterVolTagPI(filter.find((item: OptionFilterItem) => item.key === "volumeTagPI")?.filter ?? []);
            setFilterDensityTagPI(filter.find((item: OptionFilterItem) => item.key === "densityTagPI")?.filter ?? []);
            setFilterExceptionDate(filter.find((item: OptionFilterItem) => item.key === "exceptionDate")?.filter ?? []);
          } else {
            setFilterFuelName([]);
            setFilterVolInputBy([]);
            setFilterDensityInputBy([]);
            setFilterVolTagPI([]);
            setFilterDensityTagPI([]);
            setFilterExceptionDate([]);
          }
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMasterData = async () => {
    try {
      const response = await getMasterData();
      if (response.data.code === 200) {
        const master: MasterData[] = response.data.data;

        if (master.length > 0) {
          let optionUnit = master.find((el) => el.label === "unit");
          if (optionUnit && optionUnit?.options) {
            setUnitMaster(optionUnit?.options);
          }
        } else {
          setUnitMaster([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAreaMaster = async () => {
    try {
      if (companyId) {
        setLoading(true);
        const response = await getAreaMaster(companyId);
        if (response.data.code === 200) {
          setLoading(true);
          let areaMaster = response.data.data;
          if (areaMaster.length > 0) {
            areaMaster = areaMaster.map((item: any) => {
              return {
                label: item.areaName,
                value: item.areaValue,
              };
            });
            setAreaMaster(areaMaster);
          } else {
            setAreaMaster([]);
          }
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchTask = async () => {
  //   try {
  //     const companyName = profile?.activeCompany.companyName;
  //     const query = `taskName=combustion_${companyName}_tagPI&status=inprogress`;
  //     const response = await getTaskRunning(query);
  //     if (response.data.code === 200) {
  //       const task = response.data.data;
  //       if (task.length > 0) {
  //         setStatusTaskRunning(true);
  //       } else {
  //         setStatusTaskRunning(false);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleSaveCombustion = async (data: CombustionFuelVolume, combustionId: string) => {
    try {
      if (companyId) {
        data.companyId = companyId;
        if (combustionId) {
          setLoading(true);
          const tmpExceptionDateArr = data.exceptionDateArr;
          if (tmpExceptionDateArr) {
            const newExcepts = tmpExceptionDateArr.map((exc) => {
              const [start, end] = exc.split(" - ");
              return {
                startDate: moment(start).format(formatDate),
                endDate: moment(end).format(formatDate),
              };
            });
            data = {
              ...data,
              exceptionDate: newExcepts,
            };
          }
          let response = await updateFuelVolumeCombust(companyId, combustionId, data);
          const responseData: ResponseAPI = response.data;

          if (responseData.code === 200) {
            setLoading(false);
            setShowModalFuelVolume(false);
            messageApi.open({
              type: "success",
              content: CommonSuccess.SAVED_SUCCESSFULL,
            });
            processCalculateReport(combustionId);
            fetchCombustions();
          } else {
            messageApi.open({
              type: "error",
              content: CommonError.SOMETHING_WRONG,
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
      messageApi.open({
        type: "error",
        content: CommonError.SOMETHING_WRONG,
      });
    } finally {
      setLoading(false);
    }
  };

  const processCalculateReport = async (id: string) => {
    try {
      setLoading(true);
      await calculateReportVocEmission(id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModalFuelVolume = (combustion: CombustionFuelVolume) => {
    const arrayException = covertedRangesDateToStrByFormat(combustion.exceptionDate as ExceptionDate[], formatDate);
    combustion.exceptionDateArr = arrayException;
    setInitialData(combustion);
    setShowModalFuelVolume(true);
  };

  const resetFilter = () => {
    setFilterCombustion({});
  };

  const fetchMaster = async () => {
    fetchAreaMaster();
    fetchMasterData();
    // fetchTask();
  };

  useEffect(() => {
    fetchYear();
  }, []);

  useEffect(() => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  }, [profile?.activeCompany]);

  useEffect(() => {
    setSelectedYear(currentYear);
    resetFilter();
    setCurrent(1);
    fetchMaster();
  }, [companyId]);

  useEffect(() => {
    resetFilter();
    setCurrent(1);
  }, [selectedYear]);

  useEffect(() => {
    const fetchData = async () => {
      fetchOptionFilterCombustions();
    };
    fetchData();
  }, [areaMaster, selectedYear]);

  useEffect(() => {
    if (selectedYear) {
      const fetchData = async () => {
        await fetchCombustions();
      };

      fetchData();
    }
  }, [current, filterCombustion]);

  const columns: TableColumnsType<CombustionFuelVolume> = [
    {
      title: "Stack ID",
      dataIndex: "stackId",
      align: "center",
      defaultSortOrder: "descend",
      filteredValue: filterCombustion?.stackId || null,
      filters: filterStackId?.map((el: number) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Source ID",
      dataIndex: "sourceId",
      align: "center",
      filteredValue: filterCombustion?.sourceId || null,
      defaultSortOrder: "descend",
      filters: filterSourceId?.map((el: number) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Area",
      dataIndex: "area",
      align: "center",
      filters: filterArea,
      filteredValue: filterCombustion?.area || null,
      render: (value: string) => {
        const area = areaMaster.find((el) => el.value === value);
        return area ? <Text>{area.label}</Text> : null;
      },
    },
    {
      title: "Fuel Name",
      dataIndex: "fuelName",
      align: "center",
      filteredValue: filterCombustion?.fuelName || null,
      filters: filterFuelName?.map((el: string) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: <span dangerouslySetInnerHTML={{ __html: "Volume<br>Input By" }} />,
      dataIndex: "volume",
      key: "volumeInputBy",
      align: "center",
      filteredValue: filterCombustion?.volumeInputBy || null,
      filters: filterVolInputBy?.map((el: string) => {
        return {
          text: el === EmptyString ? "" : el,
          value: el,
        };
      }),
      render: (volume) => {
        return volume ? <Text>{volume.inputBy}</Text> : "";
      },
    },
    {
      title: <span dangerouslySetInnerHTML={{ __html: "Density<br>Input By" }} />,
      dataIndex: "density",
      key: "densityInputBy",
      align: "center",
      filteredValue: filterCombustion?.densityInputBy || null,
      filters: filterDensityInputBy?.map((el: string) => ({ text: el === EmptyString ? "" : el, value: el })),
      render: (density) => {
        return density ? <Text>{density.inputBy}</Text> : "";
      },
    },
    // {
    //   title: "Volume",
    //   children: [
    //     {
    //       title: "Input By",
    //       dataIndex: "volume",
    //       key: "volumeInputBy",
    //       filteredValue: filterCombustion?.volumeInputBy || null,
    //       filters: filterVolInputBy?.map((el: string) => {
    //         return {
    //           text: el === EmptyString ? "" : el,
    //           value: el,
    //         };
    //       }),
    //       render: (volume) => {
    //         return volume ? <Text>{volume.inputBy}</Text> : "";
    //       },
    //     },
    //     {
    //       title: "Tag PI",
    //       dataIndex: "volume",
    //       key: "volumeTagPI",
    //       filteredValue: filterCombustion?.volumeTagPI || null,
    //       filters: filterVolTagPI?.map((el: string) => ({ text: el === EmptyString ? "" : el, value: el })),
    //       render: (volume) => {
    //         if (volume && volume.tagPI) {
    //           return (
    //             <>
    //               {volume.tagPI.map((value: TagPI) => (
    //                 <>
    //                   <Text>{value.tagPI}</Text>
    //                   <br />
    //                 </>
    //               ))}
    //             </>
    //           );
    //         } else {
    //           return "";
    //         }
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Density",
    //   children: [
    //     {
    //       title: "Input By",
    //       dataIndex: "density",
    //       key: "densityInputBy",
    //       filteredValue: filterCombustion?.densityInputBy || null,
    //       filters: filterDensityInputBy?.map((el: string) => ({ text: el === EmptyString ? "" : el, value: el })),
    //       render: (density) => {
    //         return density ? <Text>{density.inputBy}</Text> : "";
    //       },
    //     },
    //     {
    //       title: "Tag PI / Value",
    //       dataIndex: "density",
    //       key: "densityTagPI",
    //       filteredValue: filterCombustion?.densityTagPI || null,
    //       filters: filterDensityTagPI?.map((el: string) => ({ text: el === EmptyString ? "" : el, value: el })),
    //       render: (density, record) => {
    //         if (density && density.tagPI) {
    //           return <Text>{record.density.inputBy === InputByEnum.MANUAL ? formatNumber(density.tagPI.tagPI) : density.tagPI.tagPI}</Text>;
    //         } else {
    //           return "";
    //         }
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Exception Date",
    //   dataIndex: "exceptionDate",
    //   width: 350,
    //   filteredValue: filterCombustion?.exceptionDate || null,
    //   filters: filterExceptionDate?.map((el: string) => ({
    //     text: el === EmptyString ? "" : el,
    //     value: el === EmptyString ? `${el} > ${el}` : el,
    //   })),
    //   render: (exceptionDate: ExceptionDate[]) => (
    //     <div>
    //       {exceptionDate.map((item, index) => {
    //         return (
    //           <Row key={index + "period"} className={`bg-white-500 rounded-md ${index !== 0 ? "mt-2" : ""}`}>
    //             <Col span={22}>
    //               <Tag style={{ backgroundColor: "white", margin: 2, padding: 1 }}>
    //                 <Text className="p-1">
    //                   {/* {item.startDate} */}
    //                   {moment(item.startDate).format("YYYY-MM-DD HH:mm")}
    //                   {" -> "}
    //                   {/* {item.endDate} */}
    //                   {moment(item.endDate).format("YYYY-MM-DD HH:mm")}
    //                 </Text>
    //               </Tag>
    //             </Col>
    //             <Col span={2}>
    //               <VerticalCenter>
    //                 <CalendarOutlined style={{ fontSize: 18 }} />
    //               </VerticalCenter>
    //             </Col>
    //           </Row>
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div>
          <Button
            className="border-transparent bg-transparent"
            size={"small"}
            disabled={!canEditTable(permissions) || statusTaskRunning}
            onClick={() => {
              handleOpenModalFuelVolume(record);
            }}
          >
            <BsPencilSquare size={18} color={componentPalette.blueGrey} />
          </Button>
        </div>
      ),
    },
  ];

  const onTableChange: TableProps<CombustionFuelVolume>["onChange"] = (pagination: any, filters: any) => {
    setFilterCombustion(filters);
    setCurrent(pagination.current);
    setPageSize(pagination.pageSize);
  };

  return (
    <>
      {contextHolder}
      {showModalFuelVolume && (
        <FuelVolumeModal
          open={showModalFuelVolume}
          initialData={initialData}
          unitMaster={unitMaster}
          loading={loading}
          onCancelFuelVolume={() => {
            setShowModalFuelVolume(false);
          }}
          onSaveFuelVolume={(data, combustionId) => {
            handleSaveCombustion(data, combustionId);
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "10px" }}>
        <Select
          value={selectedYear}
          style={{ width: 120 }}
          onChange={handleYearChange}
          options={optionYears.map((year) => ({ label: year, value: year }))}
          loading={loading}
          size="middle"
        />
      </div>
      <Table
        columns={columns}
        dataSource={canViewTable(permissions) ? data : []}
        onChange={onTableChange}
        rowKey="_id"
        scroll={{ x: "max-content" }}
        loading={loading}
        pagination={{
          size: "small",
          showSizeChanger: false,
          current,
          pageSize,
          total,
        }}
      />
    </>
  );
};

export default FuelVolumeTable;
